import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Login from './components/Login';
import Dashboard from './components/DashBoard';
import AddExpense from './components/AddExpense';
import RegisterForm from './components/Register';
import { ensureDefaultAdminExists } from './utils/useEnsureDefaultAdmin';
import { useEffect } from 'react';
import Index from './components/Index';
import CurrencyConverter from './utils/CurrencyConverter';


function App() {
    useEffect(() => {
      ensureDefaultAdminExists(); 
    }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/add" element={<AddExpense />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/exchange" element={<CurrencyConverter />} />
      </Routes>
    </Router>
  );
}

export default App;
